enum InvoiceFixedPriceComponentNames {
  AmountName = 'amount',
  AmountLabel = 'Amount',
  DetailsName = 'description',
  DetailsLabel = 'Details'
}

export default InvoiceFixedPriceComponentNames;
